<template>
     <div class="publicViewClass" style="padding-top:0">
        <div class="edit-step">
            <topicSteps :active = "2" :propList="propList"></topicSteps>
        </div> 
         <div id="helpChapter" class="app-inner">
              <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="reback">
            上一步
            </div>
           <el-button type="primary"   class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="onSubmit"
            >
             下一步
           </el-button>
            </div>
             <div class="helpChapter-con edit-from">
             <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  章节编辑
            </div>
        </div>
          <div class="helpChapter-con-tit flex align-cen">
                <div class="tit-ribbon">
                    共{{total}}章
                </div>
                <div class="public-btn-small mft" >
                    <div class="public-btn-small-primary" @click="addchapter(0)">
                        添加章节
                    </div>
                </div>
            </div>
                  <div class="chapter-list" v-if="list.length != 0">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item v-for="(item,index) in list" :key="item.id"  :name="item.id">
                            <template slot="title">
                                <div class="numlist-tit flex align-cen">
                                    <div class="tit-name">
                                        {{item.serialNum}} {{item.name}}
                                    </div>
                                    <div class="mft btnicon flex align-cen">

                                          <div v-if="item.trial == 1">
                                            试听课
                                        </div>
                                        <div @click.stop="addchapter(2,item.name,item.id)">
                                            新增子分类
                                        </div>
                                        <div @click.stop="addchapter(1,item.name,item.id)">
                                            编辑
                                        </div>
                                        <div @click.stop="deletchapter(0,item.children,item.id)">
                                            删除
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div v-for="childItem in item.children" :key="childItem.id" class="childrenlist flex align-cen">
                               <div class="childrenlist-tit">
                                 {{childItem.serialNum}} {{childItem.name}}
                               </div>
                               <div class="mft childrenlist-btn flex align-cen">
                                      <div class="flex align-cen"  v-if="childItem.trial == 1"  style="color:#409eff;margin-right:10px">
                                               <el-tooltip class="item" effect="dark" content="试听课" placement="top-start">
                                        <i class="icon-al-playcircle"  style="color:#409eff"></i>
                                        </el-tooltip>
                                        试听课
                                        </div>
                                  <el-tooltip class="item" effect="dark" content="修改标题" placement="top-start">
                                        <i class="icon-al-edit" @click="addchapter(3,childItem.name,childItem.id,childItem.parentId,item.trial)" style="color:#409eff"></i>
                                        </el-tooltip>
                                         <el-tooltip class="item" effect="dark" content="删除小节" placement="top-start">
                                        <i class="icon-al-delete-fill" style="color:#F56C6C"
                                        @click.stop="deletchapter(1,'',childItem.id)"
                                        ></i>
                                        </el-tooltip>
                               </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <div class="none-chapter" v-else>
                    <i class="icon-al-cry-fill"></i>
                    <p>暂无章节</p>
                </div>
             </div>
         </div>
                               <!-- 增加修改弹窗 -->
 <el-dialog
  :title="titname"
  :visible.sync="centerDialogVisible"
  width="40%"
  :append-to-body="true"
  center>
   <div class="forminfo">
    <el-form :model="formLabelAlign" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
         <el-form-item label="章节标题：" prop="headline" v-if="formLabelAlign.parentId =='0'">
              <el-input v-model="formLabelAlign.headline" clearable placeholder="请输入章节标题" class="bbb"></el-input>
        </el-form-item>
         <el-form-item label="小节标题：" prop="headline" v-else>
              <el-input v-model="formLabelAlign.headline" clearable placeholder="请输入标题" class="bbb"></el-input>
        </el-form-item>
        <el-form-item label="是否试听：" prop="trial"  v-if="formLabelAlign.parentId !='0'">
                    <el-radio v-model="formLabelAlign.trial" label="0">否</el-radio>
                    <el-radio v-model="formLabelAlign.trial" label="1">是</el-radio>
                </el-form-item>
    </el-form>
     <div class="btn" @click="addsuncc('ruleForm')">确定</div>
   </div>
</el-dialog>
    </div>
</template>
<script>
import topicSteps from "@/components/topicSteps/index.vue"; //步骤条组件
import {courseChapterList,editcourseHelpChapter,courseChapterDetail} from "@/api/index/index"  //章节列表、新增章节、章节删除
export default {
    name:'twoCourse',
    components: {
        topicSteps,
    },
    data() {
        return {
            loading:false,
            total:0,
            list:[],
            totallist:0,
            edittype:0,
            reg:'',
            titname:'添加章节',
            method:'',
            centerDialogVisible:false,
            formLabelAlign:{
                headline:'',
                courseId:'',
                parentId:'0',
                content:'',
                trial:''
            },
            editid:'',
              rules: {
             headline: [
             { required: true, message: '请正确填写标题', trigger: 'blur' },
             { min: 1, max: 50, message: '不能超过50个字符', trigger: 'blur' }
          ],
          trial:[{ required: true, message: '请选择是否试听', trigger: 'change' }],
        },
        activeNames:[],
             propList:[
            {
                steps:1,
                text:'基本信息',
            },
            {
                steps:2,
                text:'章节编辑',
            },{
                steps:3,
                text:'上传课件',
            },{
                steps:4,
                text:'完成', 
            }

        ]
        }
    },
    created() {
         if(this.$route.query.twoId){
            this.$route.meta.title = "编辑章节"
           this.chapterList()
           this.formLabelAlign.courseId = this.$route.query.twoId
        }else{
            this.$route.meta.title = "新增章节" 
        }
    },
    methods: {
          // 下一步
        onSubmit(){
            if(this.list.length != 0){
                this.$router.push({
                    name: "threeCourse",
                    query:{
                        threeId:this.$route.query.twoId,
                    }
                })
            }else{
               this.$message.error('请先添加章节及小节'); 
            }
        },
                // 删除章节
        deletchapter(type,children,id){
            if(type == 0){
             if(!children){
                this.commdel('章节',id)
            }else{
                this.$message.error('该分类下有子分类，请先删除子分类');
            }
            }else{
               this.commdel('小节',id) 
            }
       
        },
        commdel(name,id){
            let that = this
             this.$confirm('此操作将删除该' + name + ', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
              courseChapterDetail({
                id:id
              },'DELETE')
            .then(res => {
            this.$message({
                type: 'success',
                message: '删除成功!'
            });
            this.chapterList()
            })
            .catch(err => {
            })
        }).catch(() => {         
        });
        },
              // 获取章节列表
        chapterList(){
              courseChapterList({
                id:this.$route.query.twoId
              })
            .then(res => {
                
                if(res.code == 0){
                  if(res.data !==null){
                    this.list = res.data
                    this.total = res.data.length
                    if(res.data.length !=0){
                     for (const key in res.data) {
                        this.activeNames.push(res.data[key].id)
                    }
                    }
                  }else{
                    this.list = []
                  }
                }
            })
            .catch(err => {
            })
        },
        // 添加章节
        addchapter(type,name,id,pid,trial){
                // type0表示新增，type1表示修改,type2表示新增小节
            switch (type) {
                 case 0:
                  return this.edittype = 0, this.titname = "添加章节",this.centerDialogVisible = true,this.formLabelAlign.parentId = "0",this.formLabelAlign.headline = '',this.formLabelAlign.trial = '', this.$nextTick(() =>{this.$refs.ruleForm.clearValidate()})
                 case 1:
                  return this.edittype = 1, this.titname = "修改标题",this.centerDialogVisible = true, this.formLabelAlign.headline = name,this.editid = id,this.formLabelAlign.parentId = "0",this.$nextTick(() =>{this.$refs.ruleForm.clearValidate()})
                 case 2:
                  return this.edittype = 0, this.titname = "添加小节",this.centerDialogVisible = true,this.formLabelAlign.headline = '',this.formLabelAlign.parentId = id,this.formLabelAlign.trial = '',this.$nextTick(() =>{this.$refs.ruleForm.clearValidate()})
                 case 3:
                return this.edittype = 1, this.titname = "修改小节标题",this.centerDialogVisible = true,this.formLabelAlign.headline = name,this.formLabelAlign.trial = trial,this.formLabelAlign.parentId = pid,this.editid = id,this.$nextTick(() =>{this.$refs.ruleForm.clearValidate()})
            }
         
        },
               addsuncc(formName){
                let params = { ...this.formLabelAlign};
                    let method = "post"
                     if(this.edittype == 0) params = {...this.formLabelAlign},method = "post"; 
                     if(this.edittype == 1) params = {...this.formLabelAlign,id:this.editid}, method = "put"; 
                    this.$refs[formName].validate((valid) => {
                        if(valid){
                            this.commentBness(params,method)
                }
            })
        },
         commentBness(params,method){
                editcourseHelpChapter(params,method)
                        .then(res => {
                           if(res.code == 0){
                             this.centerDialogVisible = false
                            this.chapterList()
                           }else{
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
            })
        },
        // 返回上一步
        reback(){
     this.$router.push({
        name: "addCourse",
        query:{
            id:this.$route.query.twoId,
        }
        })
        },
    },
}
</script>
<style lang="scss" scoped>
#helpChapter{
    position: relative;
     .posta{
        width: calc(100% - 240px);
        position: absolute;
        background-color: rgb(255, 255, 255);
    box-shadow: rgb(240 240 240) 1px -2px 8px;
    height: 60px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    position: fixed;
    left: 240px;
    bottom: 60px;
    z-index: 6;
    padding-left: 0;
    }
    .edit-header{
        border-bottom: 1px solid #ccc;
        border-top: 1px solid #ccc;
        padding: 20px;

    }
      .edit-from{
        margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
          .helpChapter-con-tit{
            padding: 10px 12px;
            background-color:#f7f7f7;
            margin-top: 20px;
            position: relative;
            .tit-ribbon{
                padding-left: 8px;
            }
            .tit-ribbon::before{
                content: '';
                background-color: #155bd4;
                width: 3px;
                height: 14px;
                position: absolute;
                top: 18px;
                left: 12px;
            }
          }
          .none-chapter{
            text-align: center;
            padding-top: 100px;
            i{
                font-size: 50px;
               
            }
          }
          .numlist-tit{
            padding: 0 14px;
            font-size: 16px;
            width: 100%;
            .mft{
                font-size: 13px;
                color: rgb(21, 91, 212);
                div{
                    cursor: pointer;
                    position: relative;
                }
                div:not(:last-child)::after{
                    content: "|";
                   color: #e5e5e5;
                   padding: 0 5px;
                }
                
            }
          }
          .childrenlist{
            padding: 10px 30px;
            margin-top: 10px;
            background: #f7f8fa;
            .childrenlist-tit{
                font-size: 14px;
            }
            .childrenlist-btn{
                padding-right: 5px;
              i{
                 margin-right: 10px;
                  font-size: 20px;
                  cursor: pointer;
              }
            }
          }
         }
}
    .forminfo{
        p{
            padding-left: 20px;
            color: #000;
        }
     .btn{
    width: 200px;
    height: 50px;
    background-color: #409eff;
    border-radius: 0.1vh;
    border: none;
    color: #fff;
    margin: 20px auto;
    margin-bottom: 0;;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
     }
}
::v-deep{
    .el-collapse-item__wrap{
        border-bottom: none;
    }
}
</style>